import {z} from "zod";
import {EmployeeEachSummaryModel} from "./EmployeeEachSummaryModel";

const schema = z.object({
	yearMonth: z.string(),
	summaries: z.array(EmployeeEachSummaryModel.model).default([])
});

const model = schema.transform((values) => ({
	...values
}));

export const EmployeeSummaryModel = {schema, model};
export type IEmployeeSummaryModel = z.infer<typeof EmployeeSummaryModel.model>;
export const DEFAULT_EMPLOYEE_SUMMARY: IEmployeeSummaryModel = {
	yearMonth: "",
	summaries: []
};
